/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadStatus
 */
export interface PalAuthSubmissionLeadStatus {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadStatus
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadStatus
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmissionLeadStatus
     */
    is_default?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadStatus
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadStatus
     */
    background_color?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadStatus interface.
 */
export function instanceOfPalAuthSubmissionLeadStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PalAuthSubmissionLeadStatusFromJSON(json: any): PalAuthSubmissionLeadStatus {
    return PalAuthSubmissionLeadStatusFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'background_color': !exists(json, 'background_color') ? undefined : json['background_color'],
    };
}

export function PalAuthSubmissionLeadStatusToJSON(value?: PalAuthSubmissionLeadStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is_default': value.is_default,
        'color': value.color,
        'background_color': value.background_color,
    };
}

